import React from "react";
import { FooterContainer, StyledInstagram } from "./styles";
import { Typography } from "@mui/material";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

const Footer = ({ colormatrix }: { colormatrix: TemplateColorObject }) => {
	return (
		<FooterContainer colormatrix={colormatrix}>
			<Typography>Made by Viteslink</Typography>
			<a href="https://www.instagram.com/viteslink/" className={"social"} target={"_blank"} rel="noreferrer">
				<StyledInstagram colormatrix={colormatrix} />
			</a>
		</FooterContainer>
	);
};

export default Footer;
